import { EncryptString, DecryptString } from "./utils/crypto";
const appService = {
  accountEmail: "Not Available",
  returnMsisdnVariation: function (n: any) {
    //inspect the value
    let formattedKey: any = "";
    let msisdnLength = 10;
    let count = 0;
    if (n[0] === "+") {
      n = n.substring(1);
    }
    if (n.length > 2) {
      if (n[0] === "1") {
        msisdnLength = 11;
      }
      if (!isNaN(n) && n.length <= 11) {
        let remNumber = msisdnLength - n.length - 1;
        formattedKey = n;
        for (let i = 0; i <= remNumber; i++) {
          formattedKey += "0";
        }
        
        formattedKey = appService.formatPhoneNumber(formattedKey);
        formattedKey=appService.phoneNumberSubstring(formattedKey,n,count)
      }
    }
    return { realKey: n, formattedKey };
  },
  phoneNumberSubstring:function (formattedKey:any,n:any,count:any){
    for (let i = 0; i <= formattedKey.length - 1; i++) {
      if (!isNaN(formattedKey[i]) && formattedKey[i] !== " ") {
        if (n[count] && n[count] === formattedKey[i]) {
          count++;
        } else {
          formattedKey = formattedKey.substring(0, i);
          break;
        }
      }
    }
    return formattedKey;
  },
  formatPhoneNumber: function (phoneNumberString: any) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = match[1] ? "1" : "";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return "";
  },
  generateGuid: function () {
    if (DecryptString(sessionStorage.getItem("device_id"))) {
      return DecryptString(sessionStorage.getItem("device_id"));
    } else {
      const guid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          let r = (Math.random() * 16) | 0,
            v = c === "x" ? r : (r & 0x3) | 0x8;
          return v.toString(16);
        }
      );
      sessionStorage.setItem("device_id", EncryptString(guid));
      return guid;
    }
  },
  setAccountEmail: function (email: string) {
    this.accountEmail = email;
  },
};

export default appService;
